var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.item.newChildren && _vm.item.newChildren.length
        ? _c(
            "el-submenu",
            {
              ref: "subMenu",
              attrs: {
                index: _vm.item.path,
                "popper-append-to-body": "",
                "popper-class":
                  _vm.slideClass + " " + _vm.themeClass + " " + _vm.layoutType,
              },
              on: {
                click: function ($event) {
                  return _vm.handleClick(_vm.item)
                },
              },
            },
            [
              _c(
                "template",
                { slot: "title" },
                [
                  _c("item", {
                    attrs: {
                      icon: _vm.item.icon,
                      title: _vm.generateTitle(
                        _vm.item.vueName,
                        _vm.item.fullName
                      ),
                    },
                  }),
                ],
                1
              ),
              _vm._l(_vm.item.newChildren, function (child) {
                return _c("sidebar-item", {
                  key: child.enCode,
                  staticClass: "nest-menu",
                  attrs: {
                    "is-nest": true,
                    item: child,
                    "base-path": child.path,
                  },
                })
              }),
            ],
            2
          )
        : [
            _c(
              "el-menu-item",
              {
                class: { "submenu-title-noDropdown": !_vm.isNest },
                attrs: { index: _vm.item.path },
                on: {
                  click: function ($event) {
                    return _vm.handleClick(_vm.item)
                  },
                },
              },
              [
                _c("item", {
                  attrs: {
                    icon: _vm.item.icon,
                    title: _vm.generateTitle(
                      _vm.item.vueName,
                      _vm.item.fullName
                    ),
                  },
                }),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }